export const AndroidNative = {
   createVipOrder: {
      createVipOrder: function (param) {
         try {
            return window.SpeechTextJS.createVipOrder(param)//支付
         } catch (error) {
            console.log("createVipOrder", error)
         }
      },
      createVipOrderAndCallback: function (param, callback) {
         try {
            return window.TheoneCommon.createVipOrderAndCallback(param, callback)//获支付，有回调
         } catch (error) {
            console.log("createVipOrderAndCallback", error)
         }
      }
   },
   toNewPage: function (param) {
      try {
         return window.SpeechTextJS.toNewPage(param);//协议
      } catch (error) {
         console.log("createVipOrder", error)
      }
   },
   AutoPayAgreement: function () {
      try {
         window.SpeechTextJS.onClickAutoPayAgreement();//自动续费
      } catch (error) {
         console.log("error", error)
      }
   },
   finishPage: function () {
      try {
         window.SpeechTextJS.finishPage();
       } catch (error) {
         console.log("退出的error", error);
       }
   },
   getUserInfo: function () {
      try {
        return window.SpeechTextJS.getUserInfo();
       } catch (error) {
         console.log("获取用户信息", error);
       }
   },
   loginIn: function (callback) {
      try {
        window.SpeechTextJS.loginIn(callback);
       } catch (error) {
         console.log("返回", error);
       }
   },
   getArticleInfo: function () {
      try {
        return window.SpeechTextJS.getArticleInfo();
       } catch (error) {
         console.log("获取文章信息", error);
       }
   },
}


// WEBPACK FOOTER //
// ./src/utils/androidNative.js